import React, { useEffect, useState } from "react";
import { Header } from "../../../components/SpearParts/Layouts/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import SEO from "../../../components/SEO";
import {
  Button,
  Container,
  Row,
  Col,
  Image,
  InputGroup,
  Form,
} from "react-bootstrap";
import { toTitleCase } from "../../../components/utils/StringUtil";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Axios from "../../../axios/axios";
import ReviewModal from "../../Product/ReviewModal";
import ReviewCarousel from "../../Product/ReviewCarousel";
import CatalogueCard from "../../Product/CatalogueCard";
import { Footer } from "../../../components/SpearParts/Layouts/Footer";
import TopNavBar from "../../../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../../../components/SpearParts/Layouts/TopSearchBar";
import { Helmet } from "react-helmet-async";


const RentalSingleProductPage = () => {
  // Tab state (features / catalogs / reviews) like SingleProduct
  const [tab, setTab] = useState("features");

  // image selection
  const [selectedImage, setSelectedImage] = useState(0);

  // original states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const [reviews, setReviews] = useState([]);
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [message, setMessage] = useState("");
  const [isInCart, setIsInCart] = useState(false);
  const navigate = useNavigate();

  const [brand, setBrand] = useState([]);
  const [region, setRegion] = useState([]);
  const [model, setModel] = useState([]);
  const [rental, setRental] = useState([]);
  const [userInfo, setUserInfo] = useState(null);

  const modelId = rental?.modelId?._id || rental?.modelId;
  const brandId = rental?.brandId?._id || rental?.brandId;

  const [mainImage, setMainImage] = useState("");
  const [relatedProducts, setRelatedProducts] = useState([]);

  const [rentStartDate, setRentStartDate] = useState("");
  const [rentEndDate, setRentEndDate] = useState("");
  const getUserInfo = () => {
    const userInfoString = sessionStorage.getItem("userInfo");
    if (userInfoString) {
      setUserInfo(JSON.parse(userInfoString));
    }
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  // initialize mainImage when rental loads
  useEffect(() => {
    if (Array.isArray(rental?.images) && rental.images.length > 0) {
      setMainImage(rental.images[selectedImage]?.url || rental.images[0].url);
    } else {
      setMainImage("");
    }
  }, [rental, selectedImage]);

  // login data
  useEffect(() => {
    LoginData();
  }, []);

  useEffect(() => {
    getRentalData();
    fetchReview();
  }, [id]);

  useEffect(() => {
    if (rental.regionId) getRegion();
  }, [rental]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id, location.pathname]);

  useEffect(() => {
    if (rental?._id && userInfo?.customerId) {
      checkCart();
    }
  }, [rental, userInfo]);

  // fetch related products when brand present
  useEffect(() => {
    const fetchRelated = async () => {
      if (!rental?.categoryId?._id && !rental?.categoryId) return;
      try {
        const res = await Axios.get(
          `/related-rental-products?categoryId=${
            rental?.categoryId?._id || rental?.categoryId
          }&excludeId=${rental?._id}`
        );
        // setRelatedProducts(res.data || []);
        setRelatedProducts(
          Array.isArray(res.data) ? res.data : res.data.products || []
        );
      } catch (err) {
        console.error("Error fetching related rentals:", err);
      }
    };
    fetchRelated();
  }, [rental?.categoryId, rental?._id]);

  const LoginData = () => {
    const userInfoString = sessionStorage.getItem("userInfo");
    if (userInfoString) {
      setUserInfo(JSON.parse(userInfoString));
    }
  };

  const getRentalData = async () => {
    try {
      const res = await Axios.get(`/rental/get/${id}`);
      setRental(res.data);
    } catch (error) {
      console.error("Error fetching rental data", error);
    }
  };

  useEffect(() => {
    async function fetchBrand() {
      try {
        if (!brandId) return;
        const response = await Axios.get(`/brand/get/${brandId}`);
        setBrand(response.data || {});
      } catch (error) {
        console.error("Error fetching brand:", error);
      }
    }
    if (brandId) fetchBrand();
  }, [brandId]);

  useEffect(() => {
    async function fetchModel() {
      try {
        if (!modelId) return;
        const response = await Axios.get(`/model/getsingle/${modelId}`);
        setModel(response.data || {});
      } catch (error) {
        console.error("Error fetching model:", error);
      }
    }
    if (modelId) fetchModel();
  }, [modelId]);

  const getRegion = async () => {
    try {
      const result = await Axios.get(`/region/get/${rental.regionId}`);
      setRegion(result.data || {});
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReview = async () => {
    try {
      const response = await Axios.get(`review/search?partsId=${id}`); // rental product id
      const reviewsData = response.data;

      const reviewsWithName = await Promise.all(
        reviewsData.map(async (review) => {
          let customerName = "Unknown";
          if (review.customerId) {
            try {
              const res = await Axios.get(`/customer/get/${review.customerId}`);
              customerName = res.data?.customerName || "Unknown";
            } catch (err) {
              console.error("Error fetching customer:", err);
            }
          }
          return {
            ...review,
            customerName,
            createdAt: review.createdAt || new Date(),
          };
        })
      );

      setReviews(reviewsWithName);
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };

  const checkCart = async () => {
    try {
      const res = await Axios.get(
        `/cart/check/${rental?._id}/${userInfo?.customerId}`
      );
      setIsInCart(res.data.exists);
    } catch (error) {
      console.error("Error checking cart status", error);
    }
  };

  const addToCart = async () => {
    // rental-specific validation kept
    if (!rentStartDate || !rentEndDate) {
      setMessage("Please select both start and end dates.");
      return;
    }
    if (new Date(rentStartDate) > new Date(rentEndDate)) {
      setMessage("End date must be after start date.");
      return;
    }

    try {
      const cartData = {
        customerId: userInfo?.customerId,
        businessType: "rental",
        items: [
          {
            productId: rental?._id,
            productName: rental?.rentalItem || "Rental Item",
            productType: "rental",
            quantity: quantity,
            unitPrice: rental?.rentPricePerDay || 0,
            rentStartDate,
            rentEndDate,
          },
        ],
        tax: 5,
      };

      await Axios.post("/cart/create", cartData);
      setMessage("Rental item added to cart successfully!");
      setIsInCart(true);
    } catch (error) {
      console.error("Error adding to cart:", error);
      setMessage("Error adding rental item to cart.");
    }
  };

  const calculateAverageRating = (reviewsList) => {
    if (!reviewsList || reviewsList.length === 0) return "No reviews yet";
    const totalRating = reviewsList.reduce(
      (sum, r) => sum + (r.rating || 0),
      0
    );
    return (totalRating / reviewsList.length).toFixed(1);
  };

  const handleQuantityChange = (amount) => {
    setQuantity((prev) => Math.max(1, prev + amount));
  };

  const handleLoginRedirect = () => {
    sessionStorage.setItem("postLoginRedirect", location.pathname);
    navigate(`/login?redirect=${encodeURIComponent(location.pathname)}`);
  };

  const product = {
    title: "Aurora Wireless Headphones — Noise Cancelling",
    brand: "Aurora Audio",
    price: 129.99,
    oldPrice: 179.99,
    rating: 4.6,
    reviewsCount: 248,
    badges: ["Bestseller", "Limited Offer"],
    images: [
      "/images/headphone-1.jpg",
      "/images/headphone-2.jpg",
      "/images/headphone-3.jpg",
      "/images/headphone-4.jpg",
    ],
    features: [
      "Active Noise Cancellation (ANC)",
      "30 hours battery life",
      "Quick charge: 10 min = 5 hours",
      "Bluetooth 5.3 with multipoint",
      "Lightweight & foldable design",
    ],
    catalogs: [
      { name: "Specs Sheet (PDF)", href: "/files/specs-aurora.pdf" },
      { name: "Warranty & Manual", href: "/files/manual-aurora.pdf" },
    ],
    reviews: [
      {
        name: "Priya",
        rating: 5,
        date: "2025-09-15",
        text: "Amazing ANC and very comfortable for long use.",
      },
      {
        name: "Rahul",
        rating: 4,
        date: "2025-08-30",
        text: "Great sound but could be lighter. Battery excellent.",
      },
      {
        name: "Maya",
        rating: 5,
        date: "2025-07-12",
        text: "Best in this price range. Highly recommend.",
      },
    ],
  };

  // small helper for rendering badges
  const renderBadges = () => {
    if (Array.isArray(rental?.badges) && rental.badges.length > 0) {
      return rental.badges.map((b, i) => (
        <div key={i} className="badge-modern me-1">
          {b}
        </div>
      ));
    }
    if (rental?.isBestSeller) {
      return <div className="badge-modern">Bestseller</div>;
    }
    return null;
  };

  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: "url(/images/bnr-bg.png)",
  };

  const beforeImageStyle = {
    content: '""',
    position: "absolute",
    left: 0,
    top: "50px",
    width: "400px",
    height: "100%",
    backgroundImage: "url(/images/rental-before.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left top",
    backgroundSize: "contain",
    pointerEvents: "none",
    zIndex: 1,
  };



  return (
    <div className="New-Rnt-Dashboard" style={sectionStyle}>
 {rental?._id && (
  <SEO
    title={
      rental.seo?.metaTitle ||
      `${rental.rentalItem} | Asia Parts`
    }
    description={
      rental.seo?.metaDescription ||
      rental.description ||
      "High quality rental items available at Asia Parts"
    }
    keywords={
      Array.isArray(rental.seo?.metaKeywords)
        ? rental.seo.metaKeywords.join(", ")
        : ""
    }
    canonical={`https://asiapartsouq.com/rental/product/single/${rental._id}`}
    ogImage={
      rental.images?.[0]?.url ||
      "https://asiapartsouq.com/images/no-image.jpg"
    }
    ogUrl={`https://asiapartsouq.com/rental/product/single/${rental._id}`}
  />
)}

      <div className="before-image" style={beforeImageStyle}></div>
      {/* <Header /> */}

      <style>{`
        .single-product-card{background:linear-gradient(180deg,#fff,#fbfdff);border-radius:12px;padding:18px;box-shadow:0 6px 20px rgba(33,37,41,0.06)}
        .product-gallery{min-height:320px}
        .thumb-img{height:64px;object-fit:cover;border-radius:8px;border:1px solid transparent;cursor:pointer}
        .thumb-img.selected{border-color:#1b52a3}
        .main-img{width:100%;height:100%;object-fit:contain;border-radius:8px}
        .price-row{display:flex;align-items:center;gap:.75rem}
        .old-price{text-decoration:line-through;color:#8a8d93}
        .badge-modern{background:#eef6ff;color:#0b5ed7;padding:4px 8px;border-radius:999px;font-weight:600;font-size:.8rem;display:inline-block;margin-right:6px}
        .pill{display:inline-block;padding:.25rem .6rem;border-radius:999px;background:#f3f6f9;color:#253047;font-size:.78rem}
        .tab-btn{border:none;background:transparent;padding:.5rem 1rem;cursor:pointer}
        .tab-btn.active{border-bottom:3px solid #1b52a3}
        .specs-list li{padding:.25rem 0}
        .review{border-top:1px solid #eef2f6;padding:12px 0}
        .related-card{border-radius:10px;overflow:hidden}
        @media (max-width: 767.98px){
          .product-gallery{min-height:220px}
          .thumb-img{height:52px}
        }
      `}</style>
      <style>{`
  .single-product-card{background:linear-gradient(180deg,#fff,#fbfdff);border-radius:12px;padding:18px;box-shadow:0 6px 20px rgba(33,37,41,0.06)}
  .product-gallery{min-height:320px}
  .thumb-img{height:64px;object-fit:cover;border-radius:8px;border:1px solid transparent;cursor:pointer}
  .thumb-img.selected{border-color:#1b52a3}
  .main-img{width:100%;height:100%;object-fit:contain;border-radius:8px}
  .price-row{display:flex;align-items:center;gap:.75rem}
  .old-price{text-decoration:line-through;color:#8a8d93}
  .badge-modern{background:#eef6ff;color:#0b5ed7;padding:4px 8px;border-radius:999px;font-weight:600;font-size:.8rem;display:inline-block;margin-right:6px}
  .pill{display:inline-block;padding:.25rem .6rem;border-radius:999px;background:#f3f6f9;color:#253047;font-size:.78rem}
  .tab-btn{border:none;background:transparent;padding:.5rem 1rem;cursor:pointer}
  .tab-btn.active{border-bottom:3px solid #1b52a3}
  .specs-list li{padding:.25rem 0}
  .review{border-top:1px solid #eef2f6;padding:12px 0}
  .related-card{border-radius:10px;overflow:hidden}
  @media (max-width: 767.98px){
    .product-gallery{min-height:220px}
    .thumb-img{height:52px}
    .rent-controls-wrapper{flex-direction:column !important;align-items:stretch !important;width:100% !important}
    .rent-date-fields{width:100% !important;min-width:unset !important;margin-top:12px}
    .rent-controls-wrapper > div:first-child{justify-content:center;margin-bottom:8px}
  }
`}</style>

      <div className="Main-div">
        <TopNavBar />
        <div className="TopSearchBar">
          <TopSearchBar />
        </div>
        <section id="inner-banner">
          <div className="container">
            <div className="row">
              <div className="col-12 mt-5">
                <div className="card p-3 mb-5 bg-white rounded">
                  <Container>
                    <Row className="single-product-card gx-4 align-items-start">
                      {/* Gallery */}
                      <Col xs={12} lg={6}>
                        <div className="product-gallery p-2 d-flex flex-column gap-2">
                          <div
                            className="ratio ratio-4x3 bg-white p-3 d-flex align-items-center justify-content-center"
                            style={{ borderRadius: 10 }}
                          >
                            {mainImage ? (
                              <img
                                src={mainImage}
                                alt={rental?.rentalItem}
                                className="main-img"
                              />
                            ) : (
                              <img
                                src={
                                  rental?.images?.[selectedImage]?.url ||
                                  "/images/no-image.jpg"
                                }
                                alt={rental?.rentalItem || "Rental"}
                                className="main-img"
                              />
                            )}
                          </div>

                          <div className="d-flex gap-2 mt-2 overflow-auto">
                            {(rental?.images || []).map((img, i) => (
                              <img
                                key={i}
                                src={img.url}
                                alt={`thumb-${i}`}
                                onClick={() => {
                                  setSelectedImage(i);
                                  setMainImage(img.url);
                                }}
                                className={`thumb-img ${
                                  selectedImage === i ? "selected" : ""
                                }`}
                                style={{ width: 80 }}
                              />
                            ))}
                          </div>
                        </div>
                      </Col>

                      {/* Details */}
                      <Col xs={12} lg={6}>
                        <div className="p-2">
                          <div className="d-flex justify-content-between align-items-start">
                            <div>
                              <h2 style={{ marginBottom: 6, fontSize: 22 }}>
                                {toTitleCase(
                                  rental?.rentalItem || "Rental Item"
                                )}
                              </h2>

                              <div
                                className="text-muted"
                                style={{ fontSize: 13 }}
                              >
                                {toTitleCase(brand?.name || "")}
                              </div>

                              {/* Add rating below brand */}
                              <div
                                style={{
                                  fontSize: 14,
                                  fontWeight: 700,
                                  marginTop: 4,
                                }}
                              >
                                {calculateAverageRating(reviews)} ⭐
                              </div>
                              <div style={{ fontSize: 12, color: "#6c757d" }}>
                                {reviews.length} reviews
                              </div>
                            </div>
                          </div>
                          <div className="mt-3">
                            <div className="price-row">
                              <div style={{ fontSize: 24, fontWeight: 800 }}>
                                Request for price
                              </div>
                              {/* show official rent price per day if present */}
                              {/* {rental?.rentPricePerDay ? (
                              <div
                                style={{
                                  marginLeft: 12,
                                  fontSize: 16,
                                  color: "#333",
                                }}
                              >
                                ₹{Number(rental.rentPricePerDay).toFixed(2)} /
                                day
                              </div>
                            ) : null} */}
                            </div>
                            <div className="mt-2 d-flex gap-2">
                              {product.badges.map((b, i) => (
                                <div key={i} className="badge-modern">
                                  {b}
                                </div>
                              ))}
                            </div>
                            <div className="mt-2 d-flex gap-2">
                              {renderBadges()}
                            </div>
                          </div>

                          <div className="mt-4 d-flex gap-2 align-items-center">
                            {userInfo ? (
                              !isInCart ? (
                                <div
                                  className="rent-controls-wrapper d-flex gap-2 align-items-center"
                                  style={{ width: "100%" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 8,
                                    }}
                                  >
                                    <button
                                      className="btn btn-outline-secondary"
                                      onClick={() => handleQuantityChange(-1)}
                                    >
                                      -
                                    </button>
                                    <input
                                      type="number"
                                      value={quantity}
                                      onChange={(e) =>
                                        setQuantity(
                                          Math.max(
                                            1,
                                            Number(e.target.value) || 1
                                          )
                                        )
                                      }
                                      style={{ width: 72, textAlign: "center" }}
                                      className="form-control"
                                    />
                                    <button
                                      className="btn btn-outline-secondary"
                                      onClick={() => handleQuantityChange(1)}
                                    >
                                      +
                                    </button>
                                  </div>

                                  <div
                                    className="rent-date-fields"
                                    style={{ minWidth: 220, width: "100%" }}
                                  >
                                    <Row>
                                      <Col>
                                        <Form.Label>Rent From:</Form.Label>
                                        <Form.Control
                                          type="date"
                                          value={rentStartDate}
                                          onChange={(e) =>
                                            setRentStartDate(e.target.value)
                                          }
                                        />
                                      </Col>
                                      <Col>
                                        <Form.Label>Rent To:</Form.Label>
                                        <Form.Control
                                          type="date"
                                          value={rentEndDate}
                                          onChange={(e) =>
                                            setRentEndDate(e.target.value)
                                          }
                                        />
                                      </Col>
                                    </Row>
                                    <div className="mt-2">
                                      <Button
                                        variant="primary"
                                        className="w-100"
                                        onClick={addToCart}
                                        style={{ backgroundColor: "#1a54a6" }}
                                      >
                                        Add to Cart
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <Link to={`/viewcart/${rental?._id}`}>
                                  <button
                                    className="btn btn-primary"
                                    style={{ minWidth: 160 }}
                                  >
                                    View in Cart
                                  </button>
                                </Link>
                              )
                            ) : (
                              <button
                                className="btn btn-primary"
                                style={{
                                  minWidth: 220,
                                  backgroundColor: "#1a53a4",
                                  border: "none",
                                  minHeight: "40px",
                                }}
                                onClick={handleLoginRedirect}
                              >
                                Login For Request
                              </button>
                            )}
                          </div>
                          <div className="mt-3 d-flex flex-column gap-2">
                            <small className="text-muted">
                              <span>
                                Category :{" "}
                                <span className="text-secondary fw-bold">
                                  {toTitleCase(rental?.categoryId?.name)}
                                </span>
                              </span>
                            </small>
                            <small className="text-muted">
                              <span
                                className="text-secondary fw-bold"
                                style={{
                                  fontSize: "15px",
                                  fontFamily: "revert-layer",
                                  textAlign: "justify",
                                  display: "inline-block",
                                  maxWidth: "100%",
                                }}
                              >
                                {rental?.description ||
                                  "No description available."}
                              </span>
                            </small>
                            <small className="text-muted">
                              <strong>Status:</strong>{" "}
                              {rental?.availabilityStatus || "Unavailable"}
                            </small>
                          </div>
                          {message && (
                            <div className="mt-2 text-danger">{message}</div>
                          )}
                        </div>
                      </Col>

                      {/* Tabs */}
                      <Col xs={12} className="mt-3">
                        <div
                          className="d-flex border-bottom"
                          style={{ gap: 12 }}
                        >
                          <button
                            className={`tab-btn ${
                              tab === "features" ? "active" : ""
                            }`}
                            onClick={() => setTab("features")}
                          >
                            Features
                          </button>
                          <button
                            className={`tab-btn ${
                              tab === "catalogs" ? "active" : ""
                            }`}
                            onClick={() => setTab("catalogs")}
                          >
                            Catalogs
                          </button>
                          <button
                            className={`tab-btn ${
                              tab === "reviews" ? "active" : ""
                            }`}
                            onClick={() => setTab("reviews")}
                          >
                            Reviews ({reviews.length})
                          </button>
                        </div>

                        <div className="tab-content p-3">
                          {tab === "features" && (
                            <div className="row">
                              <div className="col-md-6">
                                <h5>Key features</h5>
                                <ul className="specs-list">
                                  <li>
                                    • Brand: <b>{toTitleCase(brand?.name)}</b>
                                  </li>
                                  <li>
                                    • Model: <b>{toTitleCase(model?.name)}</b>
                                  </li>
                                  <li>
                                    • Region: <b>{toTitleCase(region?.name)}</b>
                                  </li>
                                  <li>
                                    • Year: <b>{rental?.year}</b>
                                  </li>
                                  <li>
                                    • Rental Period:{" "}
                                    <b>{rental?.rentalPeriod || "Flexible"}</b>
                                  </li>
                                </ul>
                              </div>

                              <div className="col-md-6">
                                <h5>Tech specs</h5>
                                <ul className="specs-list">
                                  <li>
                                    • Availability:{" "}
                                    <b>{rental?.availabilityStatus}</b>
                                  </li>
                                  <li>
                                    • Condition:{" "}
                                    <b>{rental?.condition || "-"}</b>
                                  </li>
                                  <li>
                                    • Capacity: <b>{rental?.capacity || "-"}</b>
                                  </li>
                                  <li>
                                    • Additional Info:{" "}
                                    <b>{rental?.additionalInfo || "-"}</b>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          )}

                          {tab === "catalogs" && (
                            <div>
                              <h5>Downloads & catalogs</h5>
                              <div className="d-flex flex-column flex-sm-row gap-2">
                                {Array.isArray(rental?.catalogue) &&
                                rental.catalogue.length > 0 ? (
                                  <div className="col-lg-4">
                                    {rental.catalogue.map((catalogue, i) => (
                                      <a
                                        key={i}
                                        href={catalogue.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        download
                                        className="d-inline-block p-2 border rounded"
                                        style={{
                                          minWidth: 200,
                                          textDecoration: "none",
                                          color: "#000",
                                          margin: "10px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                        }}
                                      >
                                        <span style={{ flexGrow: 1 }}>
                                          {catalogue.name}
                                        </span>
                                        <i
                                          className="fa-solid fa-download"
                                          style={{ marginLeft: "10px" }}
                                        ></i>
                                      </a>
                                    ))}
                                  </div>
                                ) : (
                                  <img
                                    src="/images/no-image.jpg"
                                    style={{
                                      width: "250px",
                                      marginLeft: "30%",
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          )}

                          {tab === "reviews" && (
                            <div>
                              <h5>Customer reviews</h5>
                              <div>
                                {reviews.map((r, i) => (
                                  <div key={i} className="review">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div>
                                        <strong>{r.customerName}</strong>
                                        <div
                                          style={{
                                            fontSize: 13,
                                            color: "#6c757d",
                                          }}
                                        >
                                          {new Date(
                                            r.createdAt
                                          ).toLocaleDateString()}
                                        </div>
                                      </div>
                                      <div style={{ fontWeight: 700 }}>
                                        {r.rating} ⭐
                                      </div>
                                    </div>
                                    <p style={{ marginTop: 8 }}>{r.note}</p>
                                  </div>
                                ))}

                                <div className="mt-3">
                                  {userInfo && (
                                    <a
                                      href="#write-review"
                                      className="text-primary"
                                      onClick={() => setIsModalOpen(true)}
                                    >
                                      Write a review
                                    </a>
                                  )}
                                </div>

                                <ReviewModal
                                  isOpen={isModalOpen}
                                  onClose={() => setIsModalOpen(false)}
                                  id={id} // product id
                                  userInfo={userInfo}
                                  setReviews={setReviews} // update reviews after submission
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </Col>

                      {/* Related products */}
                      <Col xs={12} className="mt-4">
                        <h5>Related products</h5>
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 mt-2">
                          {relatedProducts.length > 0 ? (
                            relatedProducts.map((p) => (
                              <div key={p._id} className="col">
                                <div className="card related-card p-2 h-100">
                                  <img
                                    src={
                                      p.images?.[0]?.url ||
                                      "/images/no-image.jpg"
                                    }
                                    alt={p.name}
                                    style={{
                                      height: 140,
                                      width: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div className="card-body p-2">
                                    <h6 className="card-title mb-1">
                                      {p.name}
                                    </h6>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div style={{ fontWeight: 700 }}>
                                        Request for Price
                                        {/* {p.rentPricePerDay > 0
                                        ? `₹${Number(p.rentPricePerDay).toFixed(2)} / day`
                                        : p.price > 0
                                        ? `₹${Number(p.price).toFixed(2)}`
                                        : "Request for price"} */}
                                      </div>
                                      <Link
                                        to={`/rental/product/single/${p._id}`}
                                      >
                                        <button className="btn btn-sm btn-outline-primary">
                                          View
                                        </button>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="text-muted">
                              No related products found.
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default RentalSingleProductPage;
